import {SEAT_DETAILS, SELECTED_SSRS_SEAT_IDENTIFICATION} from './SeatType'

export const seatCredential=(props)=>
{
     
    return{
        type:SEAT_DETAILS,
        SeatResponseData:props.SeatResponseData
    }
}

export const seatIdentificationCredential = (props) => {
    return {
        type: SELECTED_SSRS_SEAT_IDENTIFICATION,
        SeatIdentification: props.SeatIdentification
    }
}